/* eslint-env browser */
import React, { FC, memo } from 'react';
import { useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import AUSubNavComponent from '@aarhus-university/au-lib-react-components/src/components/AUSubNavComponent';
import { replace } from '@aarhus-university/au-lib-react-components/src/lib/helpers';
import ProfileWidgetComponent from './ProfileWidgetComponent';
import { useTranslationsContext } from '../../lib/translation';

const ProfileAvatarComponent: FC = memo(() => {
  const userContext = useUserContext();
  const {
    firstNames,
    lastName,
  } = userContext || {};
  const translations = useTranslationsContext();

  return (
    <AUSubNavComponent
      id="profile-menu-toggle"
      className="nav__item nav__item--icon nav__item--icon--right"
      dataIcon=""
      text={firstNames || ''}
      ariaLabel={replace(translations.generics.sub_nav.toggle_aria_label, ['fullname'], [`${firstNames} ${lastName}`])}
    >
      <ProfileWidgetComponent />
    </AUSubNavComponent>
  );
});

ProfileAvatarComponent.displayName = 'AUProfileAvatarComponent';
export default ProfileAvatarComponent;
